import { render, staticRenderFns } from "./BuilderTopBar.vue?vue&type=template&id=3ceb9681&"
import script from "./BuilderTopBar.vue?vue&type=script&lang=ts&"
export * from "./BuilderTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./BuilderTopBar.vue?vue&type=style&index=0&id=3ceb9681&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports